
import {post} from '../api/ajax';

export const logger = {
  interval:30 * 1000,
  init:function(interval){
    if(interval && interval>0){
      this.interval = interval;
    }
    console.log("[Logger] Inited...",interval);
  },

  start:function(){
    // console.log("[Logger]["+this.interval+"] Started...");
    const logs = loadFromStorage();
    if(logs && logs.length>0){
      postLogs(logs);
    }
    this._task = setInterval(()=>{
      const logs = loadFromStorage();
      if(logs && logs.length>0){
        postLogs(logs);
      }
    },this.interval);
  },

  stop:function(){
    const task = this._task;
    if(_task){
      clearInterval(_task);
    }
    console.log("[Logger] Stoped...");
  },

  log:function(page) {
    var time = new Date().getTime();
    var log = {
      pageId:'',
      loadDt:time,
      pageUri:page.$route.path,
      webkit:navigator.userAgent
    }
    page.$nextTick(function(){
      var end = new Date().getTime();
      log.loadedDt = end;
      //console.log(log);
      saveToStorage([log]);
    });
  },

  error:function(err, page, info){
    var time = new Date().getTime();
    var log = {
      pageId:'',
      loadDt:time,
      pageUri:page.$route.path,
      webkit:navigator.userAgent,
      pageError:err.message
    }
    //console.log(log);
    saveToStorage([log]);
  }
};

const LOG_KEY = "_logs_";

const loadFromStorage = ()=>{
  const log = localStorage.getItem(LOG_KEY);
  if(log==null || log.length==0){
    return;
  }
  localStorage.removeItem(LOG_KEY);
  return JSON.parse(log);
}

const saveToStorage = (ls,append = true)=>{
  if(ls==null){
    return;
  }
  var logs = [];
  const log = localStorage.getItem(LOG_KEY);
  if(log!=null && log.length>0){
    logs = JSON.parse(log);
  }
  if(append){
    logs = logs.concat(ls);
  }else{
    logs = ls.concat(logs);
  }
  localStorage.setItem(LOG_KEY,JSON.stringify(logs));
}

const postLogs = (logs)=>{
  post('/api/lm/web/webLog/insertByBatch',logs).then(res=>{
    // console.log("[Logger] posted...");
  }).catch(err=>{
    // console.error("[Logger] ",err);
  });
}


// WEBPACK FOOTER //
// ./src/utils/log.js